export default __webpack_public_path__ + "static/3-c2f1a77180bc27b7c848d8ca7103aac0.jpeg";